
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { reorderWorkItem, ReorderWorkItemResponse, ReorderWorkItemPayload } from "../api/reorderWorkItem";
import { QUERY_KEYS } from "service/querykeys";

export const useReorderWorkItemMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<ReorderWorkItemResponse, any, ReorderWorkItemPayload>({
    mutationFn: reorderWorkItem,
    onSuccess: (_, variables) => {
      // Add a small delay to allow backend persistence to propagate before refetching
      setTimeout(() => {
        // Invalidate main task lists for the project
        queryClient.invalidateQueries({ queryKey: QUERY_KEYS.TASKS(variables.projectUuid) });
        
        // Invalidate infinite task lists
        queryClient.invalidateQueries({ queryKey: ["tasks", "infinite"] });
        
        // Invalidate individual task queries for this project to refresh subtasks/child items
        queryClient.invalidateQueries({ queryKey: ["task", variables.projectUuid] });

        // Invalidate infinite child lists
        queryClient.invalidateQueries({ queryKey: ["task-children-infinite"] });
        
        // Broad invalidate for safety
        queryClient.invalidateQueries({ queryKey: ["tasks"] });
      }, 1000);
    },
    onError: (error: any) => {
      console.error("Failed to reorder task", error);
    }
  });
};
